export const IS_LOCALHOST = ["localhost", "127.0.0.1"].includes(
  window.location.hostname,
);

export const API_BASE_URL = IS_LOCALHOST ? "http://localhost:3000" : "/api";

export const LANG_KEY = "paymentGatewayLang";
export const ALL_LANGS = ["en", "hi", "ko"];
export const VERIFYING_DELAY_MS = 2500;
export const STATUS_POLL_INTERVAL_MS = 60_000;
export const ACTION_COOLDOWN_MS = 5000;
export const SERVER_ERROR_STATUS = 500;

function normalizeMarket(raw) {
  return String(raw || "")
    .trim()
    .toUpperCase();
}

export function getMarket() {
  return normalizeMarket(import.meta.env.VITE_MARKET);
}

export function getSupportedLangsForMarket(market = getMarket()) {
  const normalized = normalizeMarket(market);

  if (normalized === "KRW") return ["ko", "en"];
  if (normalized === "INR") return ["hi", "en"];

  return ["en"];
}

export const UPI_FIELD_META = {
  pa: { required: true },
  pn: {},
  am: {},
  cu: {},
  tn: {},
  mc: {},
  tid: {},
  tr: {},
  url: {},
};

export const UPI_FIELD_ORDER = [
  "pa",
  "pn",
  "am",
  "cu",
  "tn",
  "mc",
  "tid",
  "tr",
  "url",
];
